import eagle from "@src/assets/nfts/eagle.png";
import desert from "@src/assets/nfts/desert.png";
import surf from "@src/assets/nfts/surf.png";
import wheel from "@src/assets/nfts/wheel.png";
import khalifa from "@src/assets/nfts/khalifa.png";
import airplane from "@src/assets/nfts/airplane.png";

const nftsPics: Record<string, string> = {
  WHEEL: wheel,
  DESERT: desert,
  SURF: surf,
  KHALIFA: khalifa,
  AIRPLANE: airplane,
  EAGLE: eagle
};

export default nftsPics;
